import { testimonials } from '@/mocks/home';

export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-500 tracking-wide">漫友真实评价</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            万千漫友的信赖之选
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            听听来自全国漫友的真实反馈，看看他们为什么选择51漫画网
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={t.id}
              className={`bg-white rounded-lg p-5 md:p-6 transition-all duration-300 hover:bg-background-100 ${
                idx >= 4 ? 'opacity-70' : ''
              }`}
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-secondary-300'}`}
                  ></i>
                ))}
              </div>
              <h4 className="font-semibold text-foreground-950 text-sm mb-2">{t.title}</h4>
              <p className="text-foreground-500 text-xs leading-relaxed mb-4 line-clamp-3">{t.content}</p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div>
                  <p className="text-foreground-950 text-sm font-semibold">{t.name}</p>
                  <p className="text-foreground-500 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}